import type { AssetId } from "../lib/workIds";
import { useWorkRequestsQuery } from "./useWorkRequestsQuery";

/**
 * Work Requests associated with a single Asset, for the asset detail
 * Analysis tab's "Work requests" panel. Thin wrapper over the shared
 * Requests list query so the asset page doesn't duplicate its filter
 * plumbing or response parsing.
 */
export function useAssetWorkRequestsQuery(assetId: AssetId | null) {
  return useWorkRequestsQuery(
    {
      view: "all",
      search: "",
      priorities: [],
      requestedBy: [],
      statuses: [],
      assetIds: assetId ? [assetId] : [],
    },
    { enabled: assetId !== null },
  );
}
